import { api_react_v1_entity_joins_path } from '../../routes';
import request from './request';

export interface SanitizedEntityJoinParams {
  entity_id: number;
  entity_source: string;
  parent_type: string;
  parent_id: number;
}

export async function createEntityJoin(values: SanitizedEntityJoinParams): Promise<boolean> {
  const resp = await request('post', api_react_v1_entity_joins_path(), { entity_join: values });
  return resp.success;
}

export async function deleteEntityJoin(values: SanitizedEntityJoinParams): Promise<boolean> {
  const resp = await request('delete', api_react_v1_entity_joins_path(), { entity_join: values });
  return resp.success;
}
